
import React from 'react';
import { Database, Settings } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const AdvancedSettingsTab: React.FC = () => {
  return (
    <Card className="p-6">
      <div className="flex items-center space-x-2 mb-6">
        <Database className="w-5 h-5 text-blue-600" />
        <h3 className="text-lg font-semibold">Advanced Settings</h3>
      </div>
      <div className="space-y-4">
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <h4 className="font-medium text-yellow-800">Database Operations</h4>
          <p className="text-sm text-yellow-700 mt-1">
            Advanced database operations should be performed with caution.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Button variant="outline" className="w-full">
            <Database className="w-4 h-4 mr-2" />
            Backup Database
          </Button>
          <Button variant="outline" className="w-full">
            <Settings className="w-4 h-4 mr-2" />
            Clear Cache
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default AdvancedSettingsTab;
